import { render, staticRenderFns } from "./customercontractlist.vue?vue&type=template&id=31b3d161"
import script from "./customercontractlist.vue?vue&type=script&lang=js"
export * from "./customercontractlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports